import React, { useState } from "react";
import { Link } from "react-router-dom";
import { axiosPost } from "../apis/useAxios";
import AuthShell, { AuthField } from "./auth/AuthShell";

/**
 * Forgot password: auth/forgot-password emails a one-time reset link to the account's email. Unknown accounts get the same
 * answer as known ones; a deactivated user is told so. The result shows in the card (no popup).
 */
export function ForgotPasswordComponent() {
  const [value, setValue] = useState("");
  const [error, setError] = useState("");
  const [result, setResult] = useState(null); // { ok, text }
  const [sending, setSending] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (value.trim() === "") {
      setError("Please enter username/email.");
      return;
    }
    setError("");
    setResult(null);
    setSending(true);
    try {
      // The reset link in the email opens this same website (the API accepts only the airline's own websites).
      const data = await axiosPost("auth/forgot-password", { UserNameOrEmail: value.trim(), WebsiteUrl: window.location.origin });
      setResult({ ok: Boolean(data?.isSuccess), text: data?.message || "Unable to send the reset link." });
    } catch (err) {
      setResult({ ok: false, text: err?.message || "Unable to send the reset link." });
    }
    setSending(false);
  };

  return (
    <AuthShell title="Forgot password?" hint="Enter your username or email and we'll send you a reset link.">
      <form method="post" onSubmit={submit} noValidate style={sending ? { pointerEvents: "none", opacity: 0.5 } : {}}>
        <AuthField id="emailAddress" label="Username / Email" icon="fas fa-envelope" error={error}>
          <input
            type="text"
            className="form-control"
            id="emailAddress"
            name="emailAddress"
            placeholder="Enter username or email"
            maxLength={100}
            autoComplete="username"
            value={value}
            onChange={(e) => setValue(e.target.value)}
            autoFocus
          />
        </AuthField>

        {result && (
          <div className={`alert ${result.ok ? "alert-success" : "alert-danger"} au-alert`} role={result.ok ? "status" : "alert"}>
            <i className={`fas ${result.ok ? "fa-envelope-open-text" : "fa-exclamation-circle"} mr-2`} aria-hidden="true" />
            {result.text}
          </div>
        )}

        <button type="submit" className="btn btn-primary btn-lg btn-block" disabled={sending}>
          <i className="fas fa-paper-plane mr-2" aria-hidden="true" />
          {sending ? "Sending…" : "Send Reset Link"}
        </button>

        <div className="au-back">
          <Link to="/" className="au-link">
            <i className="fas fa-arrow-left mr-1" aria-hidden="true" /> Back to Login
          </Link>
        </div>
      </form>
    </AuthShell>
  );
}

export default ForgotPasswordComponent;
